import { format } from "date-fns";

export function getDateFromUnixTimestamp(unixTimestamp) {
  return format(new Date(unixTimestamp), "d MMMM yyyy");
}

export function getDateTimeFromUnixTimestamp(unixTimestamp) {
  return format(new Date(unixTimestamp), "d MMMM yyyy, hh:mm aaa");
}
